module.exports = __webpack_public_path__ + "img/01.3a266672.png";